import axios from 'axios';
require('dotenv').config()

const apiViaCep = axios.create({
   baseURL:'http://viacep.com.br/ws',
})

export default apiViaCep;